import getProvinces from "./getProvinces";
import getCities from "./getCities";
import getNeighborhoods  from "./getNeighborhoods"
import createMeliAccount from "./createMeliAccount";
import saveMeliCode from "./saveMeliCode";
import getSalesChannel from "./getSalesChannel";
import updateAccount from "./updateAccount";
import updateAccountStatus from "./updateAccountStatus";
import getExposureTypes from "./getExposureTypes";
import getPublications from "./getPublications"
import updatePublication from "./updatePublication";
import createMeliPublication from "./createMeliPublication"
import {metaUpdatePages, metaGetPages} from "./meta"
import hasPublicationActiveByStockId from "./hasPublicationActiveByStockId"
import { hasWhatsappCallPermission, sendWhatsappCallRequestPermission } from './whatsappCallPermission'

export const Integrations = {
    getProvinces, 
    getCities,
    getNeighborhoods,
    createMeliAccount,
    saveMeliCode,
    getSalesChannel,
    updateAccount,
    getExposureTypes,
    getPublications,
    updatePublication,
    createMeliPublication,
    updateAccountStatus,
    metaUpdatePages,
    metaGetPages,
    hasPublicationActiveByStockId,
    hasWhatsappCallPermission,
    sendWhatsappCallRequestPermission,
};
